<template>
  <div class="onboarding-step">
    <div class="onboarding-step__wrap">
      <!-- <img class="onboarding-step__img" src="img/jpg/main.jpg" alt /> -->
      <component
        :is="component"
        :type="mfaType"
        :key="component"
        @accountCreate="changeComponent('AccountCreate')"
        @accountLogin="changeComponent('AccountLogin')"
        @submit="login"
        @submitCreate="createAccount"
        @submitMfa="submitMfa"
      ></component>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import AccountLogin from "@/components/Onboarding/AccountLogin.vue";
import AccountCreate from "@/components/Onboarding/AccountCreate.vue";
import Mfa from "@/components/Mfa.vue";

export default {
  components: {
    AccountLogin,
    AccountCreate,
    Mfa
  },

  data() {
    return {
      component: "AccountLogin",
      mfaType: null
    };
  },

  computed: {
    ...mapState({
      platformSession: state => state.platformSession,
      initPlatform: state => state.initPlatform,
      activeStep: state => state.activeStep,
      platform: state => state.user.platforms
    })
  },

  methods: {
    changeComponent(componentName) {
      this.component = componentName;
      if (document.pad) {
        document.pad.resetFocus();
      }
    },
    login(form) {
      this.$store
        .dispatch("login", {
          email: form.email,
          password: form.password
        })
        .then(res => {
          if (res.status) {
            if (Object.prototype.hasOwnProperty.call(res.data, "mfa")) {
              this.component = "Mfa";
              this.mfaType = res.data.mfa;
            } else if (Object.prototype.hasOwnProperty.call(res.data, "user")) {
              this.$store.dispatch("setUser", res.data.user).then(() => {
                if (this.platform[this.initPlatform]) {
                  this.$store.dispatch("setStep", this.activeStep + 2);
                } else {
                  this.$store.dispatch("setStep", this.activeStep + 1);
                }
              });

              // if (this.platform) {
              //   this.$store.dispatch("setStep", this.activeStep + 2);
              // } else {
              //   this.$store.dispatch("setStep", this.activeStep + 1);
              // }
              // this.$store.dispatch("setStep", this.activeStep + 1);
            }
          }
        })
        .catch(() => {});
    },

    submitMfa(code) {
      switch (this.mfaType) {
        case "sms":
          this.$store
            .dispatch("loginMfaSms", { code })
            .then(res => {
              this.$store.dispatch("setUser", res.data.user).then(() => {
                if (this.platform[this.initPlatform]) {
                  this.$store.dispatch("setStep", this.activeStep + 2);
                } else {
                  this.$store.dispatch("setStep", this.activeStep + 1);
                }
              });
              // this.$router.push({ name: "Home" });
              // this.$store.dispatch("setStep", this.activeStep + 1);
            })
            .catch(() => {});
          break;

        case "totp":
          this.$store
            .dispatch("loginMfaTotp", { code })
            .then(res => {
              this.$store.dispatch("setUser", res.data.user).then(() => {
                if (this.platform[this.initPlatform]) {
                  this.$store.dispatch("setStep", this.activeStep + 2);
                } else {
                  this.$store.dispatch("setStep", this.activeStep + 1);
                }
              });
              // this.$router.push({ name: "Home" });
              // this.$store.dispatch("setStep", this.activeStep + 1);
            })
            .catch(() => {});
          break;
      }
    },

    createAccount(form) {
      this.$store
        .dispatch("create", form)
        .then(res => {
          if (res.status) {
            this.$store
              .dispatch("login", {
                email: form.email,
                password: form.password
              })
              .then(res => {
                if (res.status) {
                  if (Object.prototype.hasOwnProperty.call(res.data, "user")) {
                    this.$store.dispatch("setUser", res.data.user);
                    this.$store.dispatch("setStep", this.activeStep + 1);
                  }
                }
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.onboarding-step {
  &__wrap {
    height: calc(100vh - 137px);
  }
}

@media screen and (max-height: 800px) {
  .onboarding-step {
    &__wrap {
      height: calc(100vh - 115px);
    }
  }
}
</style>
